import Axios from "axios";


const axiosInstance = Axios.create({
    // baseURL: process.env.REACT_APP_SRH_END_POINT,
    baseURL: "https://es.dialog.lk/secureauthmgt/adl/et/telco/exndes/secureauthmgt/api",
    // baseURL: "http://localhost:3005",
    headers: {},
    timeout: 10000
});

export default axiosInstance;